// extracted by mini-css-extract-plugin
export default {"FormSelectionContainer":"LandingPage_FormSelectionContainer__3BaRD","Button":"LandingPage_Button__pzazW"};